import { usePermissions } from '@koopajs/react';
import { useGateValue } from '@statsig/react-bindings';

export const useIsDocumentDownloadBlocked = (): boolean => {
  const isDocumentDownloadBlockedOnWorkspace = useGateValue('block_document_downloads');
  const isUserWorkspaceOwner = usePermissions({ requiredPermissions: 'owner' });

  return isDocumentDownloadBlockedOnWorkspace && !isUserWorkspaceOwner;
};
